<template>
  <div class="knowledge">
    <div class="status-bar">
      <template v-for="(status,index) in [knowledge.level3, knowledge.level2, knowledge.level1]">
        <span v-if="status" :key="index" :style="{background: knowledgeColor(index), width: knowledgeWidth(status)}" class="status"></span>
      </template>
    </div>
    <div class="knowledge-text">{{knowledge.name}}</div>
  </div>
</template>

<script>
export default {
  name: 'knowledgeBar',
  props: ['knowledge'],
  methods: {
    knowledgeColor (index) {
      return ['rgba(70, 171, 255, 1)', 'rgba(255, 218, 152, 1)', 'rgba(255, 177, 181, 1)'][index]
    },
    knowledgeWidth (status) {
      let total = [this.knowledge.level3, this.knowledge.level2, this.knowledge.level1].reduce((num, item) => {
        num += item
        return num
      }, 0)
      let percent = parseFloat(status / total * 100) + '%'
      return percent
    }
  }
}
</script>

<style lang="scss" scoped>
  .knowledge{
    background:rgba(255,255,255,1);
    box-shadow:0 4px 14px 0 rgba(0,0,0,0.06);
    border-radius:10px;
    overflow: hidden;
    /*min-height: 40px;*/
    margin-top: 14px;
    .status-bar{
      height: 5px;
      position: relative;
      line-height: 0;
      .status{
        display: inline-block;
        height: 5px;
      }
      .status:first-child{
        border-top-left-radius: 10px;
      }
      .status:last-child{
        border-radius: 0 10px 0 0;
      }
    }
    .knowledge-text{
      /*min-height: 36px;*/
      font-size:15px;
      font-family:PingFangSC-Medium;
      font-weight:500;
      color:rgba(51,51,51,1);
      word-break: break-all;
      padding: 6px 0 9px 9px;
      text-align: left;
    }
  }
  @media only screen and (max-width: 1366px) {
    .knowledge{
      background:rgba(255,255,255,1);
      box-shadow:0 4px 14px 0 rgba(0,0,0,0.06);
      border-radius:10px;
      overflow: hidden;
      /*height: 34px;*/
      width: 280px;
      box-sizing: border-box;
      margin-top: 21px;
      .status-bar{
        height: 5px;
        position: relative;
        line-height: 0;
        .status{
          display: inline-block;
          height: 5px;
        }
      }
      .knowledge-text{
        /*min-height: 36px;*/
        font-size:15px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(51,51,51,1);
        word-break: break-all;
        padding: 6px 0 9px 9px;
        text-align: left;
      }
    }
  }
  @media only screen and (max-width: 1024px) {
    .knowledge{
      margin-right: 12px;
      background:rgba(255,255,255,1);
      box-shadow:0 4px 14px 0 rgba(0,0,0,0.06);
      border-radius:10px;
      overflow: hidden;
      height: 34px;
      width: 270px;
      margin-top: 21px;
      .status-bar{
        height: 5px;
        position: relative;
        line-height: 0;
        .status{
          display: inline-block;
          height: 5px;
        }
      }
      .knowledge-text{
        min-height: 36px;
        font-size:15px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(51,51,51,1);
        word-break: break-all;
        padding: 6px 0 9px 9px;
        text-align: left;
      }
    }
  }
</style>
